<template>
  <div class="main">
    <div class="login-page">
      <div class="login-page-content">
        <div class="login-box">
          <div class="login-title">管理平台</div>
          <div style="margint-top: 10px">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="0"
              size="medium"
            >
              <el-tabs v-model="activeName">
                <!-- <el-tabs v-model="activeName" @tab-click="handleTabClick"> -->
                <!-- <el-tab-pane label="账号密码登录" name="2"> -->
                <div class="login-form-box">
                  <el-form-item label="" prop="username">
                    <el-input
                      v-model="ruleForm.username"
                      placeholder="请输入手机号/用户名"
                      prefix-icon="el-icon-s-custom"
                      @blur="checkSheet"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="" prop="pwd">
                    <el-input
                      type="password"
                      v-model="ruleForm.pwd"
                      placeholder="请输入密码"
                      prefix-icon="el-icon-lock"
                    >
                    </el-input>
                  </el-form-item>
                  <el-form-item label="" prop="sheet">
                    <el-select
                      v-model="ruleForm.sheet"
                      placeholder="请选择归属街道"
                    >
                      <el-option
                        v-for="item in streetlist"
                        :key="item.id"
                        :label="item.label"
                        :value="[item.value.apibaseurl,item.value.uploadbaseurl]"
                      >
                      {{ item.label }}
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="ys_rem_for" style="margin-top: 0px">
                  <el-checkbox v-model="ruleForm.remember_me">
                    记住我
                  </el-checkbox>
                  <span
                    class="ys_send_again"
                    @click="forget_password_visible = true"
                    >忘记密码？</span
                  >
                </div>
              </el-tabs>

              <el-form-item
                prop="region"
                style="margin-bottom: 0; margin-top: 40px"
                v-if="activeName != 3"
              >
                <el-button
                  type="primary"
                  size="medium"
                  @click="commit('ruleForm')"
                  style="width: 100%"
                  :loading="loading"
                  >立即登录</el-button
                >
              </el-form-item>
            </el-form>
            <a href="http://beian.miit.gov.cn/" target="_blank">粤ICP备2023079465号-1</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/utils/store";
import appConfig from '/public/config.js'
// import { SHEET_LIST } from "../../config/sheet/sheet.js";

export default {
  name: "Login",
  data() {
    return {
      show_username_tips: false,
      show_pwd_tips: false,
      loading: false,
      forget_password_visible: false,
      ruleForm: {
        username: "",
        pwd: "",
        sheet: [],
      },
      qrcode_url: "", //扫码登录图片路径
      connecting: false, //当前是否处于正在连接状态
      qr_loading: false,
      tag: "",
      qrcode_login_success: false, //是否扫码成功
      heart_timehander: false,
      rules: {
        username: [
          { required: true, message: "请输入手机号/用户名", trigger: "change" },
        ],
        pwd: [{ required: true, message: "请输入密码", trigger: "change" }],
        sheet: [{ required: true, message: "请选择街道", trigger: "change" }],
      },
      activeName: "2",
      sms_init: false,
      captchaObj: {},
      geetest_challenge: "",
      geetest_validate: "",
      geetest_seccode: "",
      time_dec: 0,
      // sheetList: SHEET_LIST,
      streetlist:{}
    };
  },
  beforeMount() {
      store.delete("BASE_URL");
      store.delete("UPLOAD_URL");
      console.log("Login.beforeMount done");
  },

  mounted() {
    //按enter键进行登录
    window.addEventListener("keydown", this.handleEnterLogin);
    
    this.$_axios.base_url = appConfig.admin_base_url;
  },

  watch: {
    username(val) {
      if (val) {
        this.show_username_tips = false;
      }
    },
    pwd(val) {
      if (val) {
        this.show_pwd_tips = false;
      }
    },
  },

  methods: {
    checkSheet() {
        console.log('checkSheet:' + this.ruleForm.username)
        // 
        this.$_invoke("login_login", {
            ...this.ruleForm
        }).then(ret => {
            // console.log(SHEET_LIST);
            var list = [];
            for (var i in ret.streetlist) {
                var object = {};
                var objvalue = {};
                object.label = ret.streetlist[i].label;
                
                objvalue.apibaseurl = ret.streetlist[i].apiadmbaseurl;
                objvalue.uploadbaseurl = ret.streetlist[i].uploadadmbaseurl;
                objvalue.fulllabel = ret.streetlist[i].fulllabel;
                
                object.value = objvalue;
                list.push(object);
            }
            this.streetlist = list;
            console.log(this.streetlist);
            // this.streetList.key = this.streetList.sheet_key
            
            // this.sheetList = SHEET_LIST.filter((item)=>item.key=='SHEET_UAT')
            
        }).catch(() => {
            console.log('check accessRight failed.');
        })
    },
      
      
    //按enter键登录
    handleEnterLogin(e) {
      //如果是回车则执行登录方法
      if (
        e.keyCode == 13 &&
        (this.activeName == "1" || this.activeName == "2")
      ) {
        this.commit("ruleForm");
      }
    },
    changeSelector(e){
      console.log(e);
    },
    //登录
    commit(formName) {
      this.$_axios.base_url = this.ruleForm.sheet[0];
      this.$_config.upload_url = this.ruleForm.sheet[1];
      store.set("BASE_URL", this.$_axios.base_url);
      store.set("UPLOAD_URL", this.$_config.upload_url);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //发起登录请求
          this.loading = true;
          let method = "login_login";
          if (this.activeName == 1) {
            //短信验证码登录
            method = "session_smsLogin";
          }
          this.$_invoke(method, this.ruleForm)
            .then((res) => {
              // console.log(res.token)

              this.$_msg.success("登录成功");
              store.set("token", res.token);
              this.$router.push("/admin/home");
              //销毁按钮事件
              window.removeEventListener(
                "keydown",
                this.handleEnterLogin,
                false
              );
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  display: block;

  .login-page {
    @include common-box-sizing();
    width: 100%;
    height: 100vh;
    box-sizing: border-box;
    background: rgb(152, 152, 154);
    overflow: auto;

    background-image: url("../../assets/images/login-bg.jpg");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    // -webkit-filter: blur(15px); //模糊
    // -moz-filter: blur(15px); //模糊
    // -o-filter: blur(15px); //模糊
    // -ms-filter: blur(15px); //模糊
    // filter: blur(15px); //模糊

    .login-page-content {
      @include common-box-sizing();
      min-height: 600px;
      height: calc(100% - 40px);

      .login-box {
        position: absolute;
        right: 100px;
        top: 50%;
        left: 51%;
        margin-left: -250px;
        margin-top: -250px;
        width: 460px;
        padding: 0 50px 25px 50px;
        background: #fff;
        @include border-radius(10px);
        @include box-shadow(0 1px 3px rgba(0, 0, 0, 0.1));

        ::v-deep .el-tabs__nav-wrap::after {
          background-color: transparent;
        }

        // ::v-deep .el-tabs__item.is-active {
        // 	color: #0c87ff;
        // }

        // ::v-deep .el-tabs__active-bar {
        // 	background-color: #0c87ff;
        // }

        ::v-deep .el-tabs__item {
          font-size: 16px;
        }

        .login-title {
          font-size: 25px;
          margin-bottom: 25px;
          font-weight: bold;
          color: $font-color-light;
          text-align: center;
          color: #333333;
          margin-top: 20px;
        }

        ::v-deep .el-tabs__item {
          color: #aaaaaa;
        }

        ::v-deep .el-tabs__item.is-active {
          color: $primary-color;
        }

        .login-form-box {
          margin-top: 10px;

          ::v-deep .el-form-item {
            margin-bottom: 30px;
          }
          ::v-deep .el-input--medium .el-input__inner {
            height: 45px;
            line-height: 45px;
            font-size: 15px;
          }

          ::v-deep .el-input--medium .el-input__icon {
            font-size: 18px;
            margin-top: 2px;
          }
        }

        ::v-deep .el-button {
          padding: 14px 20px;
        }
      }

      .login-qrcode {
        position: relative;
      }

      .login-qrcode-container {
        text-align: center;
        width: auto;
      }
      .ys_rem_for {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .ys_send_again {
        color: $primary-color;
        cursor: pointer;
      }
      .qrcode-login-success {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 999;
        background: rgba(255, 255, 255, 0.5);
        display: table;
        width: 100%;
        height: 100%;

        .qrcode-login-success-icon {
          text-align: center;
          display: table-cell;
          vertical-align: middle;
          .qr-icon-success {
            font-size: 50px;
            color: $success-color;
          }
        }
      }
    }
  }
}

.logo {
  vertical-align: middle;
  width: 200px;
  margin-right: 10px;
}
</style>
